export default __webpack_public_path__ + "static/media/pouch-connect-logo.3df4f73b.svg";